import { axiosAction } from '../../utils/axiosAction';
import { constructSearchObj } from '../../utils/utils';
import {
  FETCH_UPLOAD_HISTORY,
  FETCH_UPLOAD_REPORT,
  UPLOAD_HISTORY_SET_PAGE,
  UPLOAD_HISTORY_SET_ROWS_PER_PAGE,
  VIEW_REPORT_SET_PAGE,
  VIEW_REPORT_SET_ROWS_PER_PAGE,
  DOWNLOAD_EXCEL,
} from '../action-types/upload-history-types';

const HISTORY_ENDPOINT = `${process.env.REACT_APP_ENDPOINT_MASS_UPLOAD_HISTORY}`;
const DOWNLOAD_EXCEL_ENDPOINT = `${process.env.REACT_APP_ENDPOINT_DOWNLOAD_EXCEL}`;

export const getUploadHistory = searchObj => async dispatch => {
  return axiosAction.get(
    `${HISTORY_ENDPOINT}${constructSearchObj(searchObj)}`,
    FETCH_UPLOAD_HISTORY,
    dispatch,
  );
};

export const getReport = (reportId, searchObj) => async dispatch => {
  return axiosAction.get(
    `${HISTORY_ENDPOINT}/${reportId}/history${constructSearchObj(searchObj)}`,
    FETCH_UPLOAD_REPORT,
    dispatch,
  );
};

export const downloadExcel = searchObj => async dispatch => {
  return axiosAction.get(
    `${DOWNLOAD_EXCEL_ENDPOINT}${constructSearchObj(searchObj)}`,
    DOWNLOAD_EXCEL,
    dispatch,
  );
};

export const setRowsPerPageAction = payload => ({
  type: UPLOAD_HISTORY_SET_ROWS_PER_PAGE,
  payload,
});
export const setViewReportRowsPerPageAction = payload => ({
  type: VIEW_REPORT_SET_ROWS_PER_PAGE,
  payload,
});

export const setPageAction = payload => ({
  type: UPLOAD_HISTORY_SET_PAGE,
  payload,
});

export const setViewReportPageAction = payload => ({
  type: VIEW_REPORT_SET_PAGE,
  payload,
});
